import React from 'react';
import { ModuleInterface } from '../types';
import { Select } from 'ui';
import { useT } from 'hooks/Locale/useT';

interface StaticSelectFieldProps extends ModuleInterface {}

/**
 * Static option select for the generic Filter modal — no endpoint, options
 * come from `manualOptions` (value => translation key).
 */
const StaticSelectField: React.FC<StaticSelectFieldProps> = ({ layout, ...field }) => {
    const t = useT();

    const options = Object.fromEntries(
        Object.entries(field.manualOptions ?? {}).map(([value, labelKey]) => [value, t(labelKey)])
    );

    return (
        <Select
            label={field.label}
            name={field.name}
            allowClear
            mode={field.mode}
            manualOptions={options}
            customLayout={layout}
            validation={{ required: field.required ?? false }}
        />
    );
};

export default StaticSelectField;
